import { combineReducers } from 'redux';

import { entities } from './entities';
import errors from './errors';
import { locale } from './i18n';
import loaded from './loaded';
import loaders from './loaders';
import main from './main';
import paginations from './paginations';
import rgpd from './rgpd';
import search from './search';
import user from './user';

const rootReducer = combineReducers({
  paginations,
  entities,
  locale,
  loaders,
  errors,
  search,
  loaded,
  rgpd,
  main,
  user,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
